/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd and/or Orbit Tickets Ltd. All rights reserved.
This file contains a combination of:
- Protected Intellectual Property owned by Kaleida Ltd; and
- Custom / Included Intellectual Property owned by the Customer,
and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (being any application not developed by Kaleida), whether or not such application forms part of the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, where separation between Protected Intellectual Property and Custom / Included Intellectual Property is unclear, this file shall be treated as containing Protected Intellectual Property.
*/

// IP-NOTICE: MIXED
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { EditorModule } from '@tinymce/tinymce-angular';
import { AppMaterialModule } from 'app/core/app-material/app-material.module';
import { HeaderComponent } from 'app/layout/header/header.component';
import { LayoutComponent } from 'app/layout/layout-component/layout.component';
import { LayoutRoutesModule } from 'app/layout/layout-routes/layout-routes.module';
import { TreeMenuComponent } from 'app/layout/tree-menu/tree-menu.component';
import { TimeProviderCreateUpdateComponent } from 'app/modules/configuration/time-provider/time-provider-create-update/time-provider-create-update.component';
import { ExternalRaiseDefectModule } from 'app/modules/external-raise-defect/external-raise-defect.module';
import { BlockUIModule } from 'ng-block-ui';
import { SharedModule } from '../shared/shared.module';
import { AsideContainerComponent } from './components/aside-container/aside-container.component';
import { DefaultAsideComponent } from './components/aside-container/default-aside.component';
import { LaunchComponent } from './components/launch/launch.component';
import { MenuComponent } from './components/menu/menu.component';
import { MenuService } from './components/menu/menu.service';
import { UserResetPasswordModule } from './components/user-reset-password/user-reset-password.module';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { WelcomeService } from './components/welcome/welcome.service';
import { AsideContentDirective } from './directives/aside-content.directive';
import { HeaderService } from './services/header.service';
import { MainMenuService } from './services/main-menu.service';
import { ResponsiveService } from './services/responsive.service';
import { SideMenuComponent } from './side-menu/side-menu.component/side-menu.component';
import { BlockTemplateComponent } from './components/block-ui/block-template.component';

@NgModule({
  declarations: [
    LayoutComponent,
    HeaderComponent,
    TreeMenuComponent,
    SideMenuComponent,
    MenuComponent,
    DefaultAsideComponent,
    AsideContainerComponent,
    AsideContentDirective,
    TimeProviderCreateUpdateComponent,
    WelcomeComponent,
    BlockTemplateComponent,
    LaunchComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BlockUIModule,
    SharedModule,
    AppMaterialModule,
    UserResetPasswordModule,
    ExternalRaiseDefectModule,
    EditorModule,
    LayoutRoutesModule,
  ],
  providers: [
    MenuService,
    ResponsiveService,
    MainMenuService,
    AppMaterialModule,
    WelcomeService,
    HeaderService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class LayoutModule {}
